<template>
  <div :class="['toaster', scope.type]">
    <span v-if="scope" class="icon-wrap">
      <fa :icon="parseContent(scope.type, 'icon')" class="icon" />
    </span>
    <div class="content">
      <header>
        <h6>{{ scope.title ? scope.title : parseContent(scope.type,'title') }}</h6>
        <small>Agora</small>
      </header>
      <p v-html="scope.msg"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Array
    },
    scope: {
      type: Object,
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    parseContent (type, target) {
      const fallback = this.config && this.config.length ? this.config[0] : {}
      const match = this.config ? this.config.filter( a => a.type == type)[0] : null
      return match ? match[target] : fallback[target]
    },
    limitMsg ( message ) {
      const limit = 75
      return message.length > limit ? message.substring(0,limit) + ' (...)' : message
    }
  }
}
</script>

<style lang="scss" scoped>
  .toaster {
    width: 100%;
    min-height: 92px;
    display: flex;
    align-items: flex-start;
    gap: 14px;
    position: relative;
    overflow: hidden;
    padding: 18px 18px 18px 20px;
    color: #163247;
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid #dce7ef;
    border-radius: 14px;
    box-shadow: 0 18px 48px rgba(12, 34, 52, 0.16);
    backdrop-filter: blur(10px);

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 5px;
      height: 100%;
      background: #ff0036;
    }

    .icon-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 46px;
      height: 46px;
      min-width: 46px;
      min-height: 46px;
      border-radius: 12px;
      text-align: center;
      background: #fff2f5;
      color: #ff0036;

      .icon {
        font-size: 20px;
      }
    }

    .content {
      flex: 1;
      min-width: 0;

      header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        width: 100%;
        margin-bottom: 6px;

        h6 {
          margin: 0;
          padding: 0;
          color: #08243a;
          font-size: 14px;
          font-weight: 800;
          line-height: 1.25;
        }

        small {
          color: #8294a3;
          font-size: 10px;
          font-weight: 700;
          line-height: 1.2;
          text-transform: uppercase;
          white-space: nowrap;
        }
      }

      p {
        display: -webkit-box;
        margin: 0;
        padding: 0;
        overflow: hidden;
        color: #5d7283;
        font-size: 12px;
        line-height: 1.45;
        white-space: normal;
        word-break: break-word;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }

    &.apollo {
      &::before { background: #ffb800; }
      .icon-wrap { color: #bf8700; background: #fff6d8; }
    }
    &.sincronismo {
      &::before { background: #00bcd4; }
      .icon-wrap { color: #008fa3; background: #ddf8fb; }
    }
    &.atividades {
      &::before { background: #25b36a; }
      .icon-wrap { color: #18834d; background: #e3f8ed; }
    }
    &.relatorios {
      &::before { background: #6f63ff; }
      .icon-wrap { color: #4e43d9; background: #eeedff; }
    }
    &.jarvis {
      &::before { background: #ff0036; }
      .icon-wrap { color: #ff0036; background: #fff2f5; }
    }
  }
</style>



<!-- {          
  type: "apollo" //apollo, sincronismo, atividades, relatorios, jarvis,
  title: "Seu título",
  msg: "Sua mensagem",
  timestamp: "0000-00-00 00:00:00"
} -->
